import React, { useEffect, useState } from 'react'
import { webhookResponsePromotionalAddon, webhookResponseappointmentWhatsappList, imgFolder, offerListApi,clientListApi } from '../../../Context/api'
import axios from 'axios'
import { commonMessage, statusCodes } from '../../../Constants/generalConfig'
import { toast } from 'react-toastify'
import moment from 'moment/moment'
import { useNavigate, } from 'react-router-dom'
import Spinner from '../../../Components/spinner/spinner'
import Paginations from '../../../Components/Pagination/pagination'
import NoRecord from '../../../Components/noRecord'
import DummyLogo from '../../../Assets/images/dummyimg.png'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
const PromotionalMessage = () => {
    const navigate = useNavigate()
    const [promotionalAddonData, setPromotionalAddonData] = useState([])
    const [promotionalAddonDataAppointment, setPromotionalAddonDataAppointment] = useState([])
    const [offerListData, setOfferListData] = useState([])
    const [count, setCount] = useState('')
    const [page, setPage] = useState(1)
    const [countAppointment, setCountAppointment] = useState('')
    const [pageAppointment, setPageAppointment] = useState(1)
    const PER_PAGE = 10
    const [spinner, setSpinner] = useState(false)
    const userData = JSON.parse(localStorage.getItem('userData'))
    const [tab, setTab] = useState(1)
    const [clientList, SetClientList] = useState([])
    const [clientId, setClientId] = useState(null)
    const [offerId, setOfferId] = useState(null)
const [selectedClient, setSelectedClient] = useState('');
const [selectedOffer, setSelectedOffer] = useState('');



    useEffect(() => {

        if (tab === 1) {

            promotionalAddonHistory()
        }
        if (tab === 2) {

            promotionalAddonHistoryAppointment()
        }
        offerList()
        getClientList()
    }, [page, tab])

       const getClientList = () => {
            const data = {
                userId: userData?.providerId,
                isActive: true,
                count: 1000,
                isAccepted: '',
                searchText: '',
                isProviderClient: true
            }
            
    
            setSpinner(true)
            axios.post(clientListApi(), { ...data }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
    
                    let filteredUsers = resp.data.data;
                    SetClientList(filteredUsers);
    
                }
                else {
                    SetClientList([])
                }
                setSpinner(false)
            }).catch(() => {
                setSpinner(false)
                toast.error(commonMessage.networkError)
            })
        }
    const promotionalAddonHistory = (offerId = null,clientId = null) => {
        setSpinner(true);
        const data = {
            clientId:clientId,
            providerId: userData?.providerId,
            messageType: "OFFER",
            page: page,
            count: PER_PAGE,
        };
        if (offerId != null) data.offerId = offerId;

        axios
            .post(webhookResponsePromotionalAddon(), data, {
                headers: { Authorization: `Bearer ${userData.token}` },
            })
            .then((resp) => {
                setSpinner(false);
                if (resp.data.code === statusCodes.ok) {
                    setPromotionalAddonData(resp.data.data || []);  // Always set data
                    setCount(resp.data.totalCount || 0);             // Always set count
                } else {
                    setPromotionalAddonData([]);  // Fallback in case of non-ok code
                    setCount(0);
                }
            })
            .catch(() => {
                setSpinner(false);
                setPromotionalAddonData([]);
                setCount(0);
                toast.error(commonMessage.networkError);
            });
    };

    const promotionalAddonHistoryAppointment = () => {
        setSpinner(true);
        const data = {
            providerId: userData?.providerId,
            messageType: "APPOINTMENT",
            page: pageAppointment,
            count: PER_PAGE,
        };

        axios
            .post(webhookResponseappointmentWhatsappList(), data, {
                headers: { Authorization: `Bearer ${userData.token}` },
            })
            .then((resp) => {
                setSpinner(false);
                if (resp.data.code === statusCodes.ok) {
                    setPromotionalAddonDataAppointment(resp.data.data || []);
                    setCountAppointment(resp.data.totalCount || 0);
                } else {
                    setPromotionalAddonDataAppointment([]);
                    setCountAppointment(0);
                }
            })
            .catch(() => {
                setSpinner(false);
                setPromotionalAddonDataAppointment([]);
                setCountAppointment(0);
                toast.error(commonMessage.networkError);
            });
    };

    const offerList = () => {
        setSpinner(true)
        const data = {
            "userId": userData?.providerId,
            "isDeleted": false,
            "searchText": "",
            "page": 1,
            "count": 10000,
            "offerType": "OFFER",
            "filter": "ALL"
        }
        axios.post(offerListApi(), data, { headers: { Authorization: `Bearer ${userData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setOfferListData(resp.data.data)
                setSpinner(false)
            }
            else {
                setSpinner(false)

            }
        }).catch(() => {
            setSpinner(false)
            toast.error(commonMessage.networkError)
        })
    }
 const handleChangeOfferData = (event) => {
        const selectedId = event.target.value;
        setOfferId(selectedId);
          setSelectedOffer(selectedId);

    };

    const handleChangeClientData = (event) => {
        const selectedId = event.target.value;
        setClientId(selectedId);
          setSelectedClient(selectedId);

    };
 const reset = () => {
    setClientId(null);
    setOfferId(null);
    setSelectedClient('');
    setSelectedOffer('');
    promotionalAddonHistory(null, null);
};


    useEffect(() => {
    
            promotionalAddonHistory(offerId, clientId);
        
    }, [offerId, clientId]); // <-- runs whenever offerId or clientId changes

    return (
        <>
            <section>
                <div className="m-t-3 cus-padd cusheight">
                    {spinner && <Spinner />}
                    <header>
                        <h2 className="page-tittle"><i className="fa-solid fa-angle-left cusgap cursor mb-1" onClick={() => navigate(-1)}></i>Promotional Message History</h2>
                        <hr />
                    </header>
                    <div className="row">
                        <div className="col-sm-12 listpadding">
                            <nav className="mb-3">
                                <div className="nav nav-tabs tabber" id="nav-tab" role="tablist">
                                    <button
                                        className={` ${tab === 1 ? 'activeNav' : 'unActiveNav'} border-0`}
                                        onClick={() => {
                                            setTab(1);
                                            setPage(1);
                                            setCount(0);
                                            promotionalAddonHistory();
                                        }}
                                        type="button"
                                    >
                                        Offer History
                                    </button>
                                    <button
                                        className={` ${tab === 2 ? 'activeNav' : 'unActiveNav'} border-0`}
                                        onClick={() => {
                                            setTab(2);
                                            setPageAppointment(1);
                                            setCountAppointment(0); // 🔧 Reset before fetching
                                            promotionalAddonHistoryAppointment();
                                        }}
                                        type="button"
                                    >
                                        Appointment History
                                    </button>

                                </div>
                            </nav>
                            {
                                tab === 1 &&
                                <>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>

                                        <div>
                                            <select
                                                className="form-select form-control"
                                                style={{ width: '300px' }}
                                                aria-label="Default select example"
                                                name="staff"
                                                onChange={handleChangeClientData}
                                                  value={selectedClient}
                                           >
                                                <option value="" hidden disabled>
                                                    Select Client
                                                </option>
                                                {clientList?.map((item) => (
                                                    <option value={item._id} key={item._id}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <select
                                                className="form-select form-control"
                                                style={{ width: '300px' }}
                                                aria-label="Default select example"
                                                name="staff"
                                                onChange={handleChangeOfferData}
                                               value={selectedOffer}
                                            >
                                                <option value="" hidden disabled>
                                                    Select Offer
                                                </option>
                                                {offerListData?.map((item) => (
                                                    <option value={item._id} key={item._id}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>


<div>
  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Reset</Tooltip>}>
    <i
      className="fa fa-refresh ms-3 mt-2 me-1"
      aria-hidden="true"
      onClick={reset} // <-- change this from onChange to onClick
      style={{ marginRight: '-10px', cursor: 'pointer' }}
    ></i>
  </OverlayTrigger>
</div>



                                    </div>





                                    {



                                        !promotionalAddonData?.length ? <NoRecord /> :

                                            <div className="table-responsive">
                                                <table className="table cus-table">
                                                    <thead className="text-center tableheader">
                                                        <tr>
                                                            <th scope="col">Image</th>
                                                            <th scope="col">Client</th>
                                                            <th scope="col">Offer Name</th>
                                                            <th scope="col">Discount Type</th>
                                                            <th scope="col">Send Time</th>
                                                            <th scope="col">Delivered Time</th>
                                                            <th scope="col">Read Time</th>
                                                            <th scope="col">Status</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {promotionalAddonData?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td><img alt="" src={(item.image === '' || item.image === null || item.image === 'null') ? DummyLogo : imgFolder + item.image} height={30} width={30} style={{ borderRadius: '50%' }} /></td>
                                                                <td>{item.userName}</td>
                                                                <td>{item.name}</td>
                                                                <td>{item.discountType}</td>
                                                                <td>{moment(item.sentDateTime).format("DD-MM-YYYY hh:mm A")}</td>
                                                                <td>{item.deliveredDateTime ? moment(item.deliveredDateTime).format("DD-MM-YYYY hh:mm A") : ""}</td>
                                                                <td>{item.readDateTime ? moment(item.readDateTime).format("DD-MM-YYYY hh:mm A") : ''}</td>
                                                                <td>{item.status}</td>

                                                                {/* <td onClick={() => handleClick(item)}>
                                  {moment(item.startDate).format('DD-MM-YYYY')} To {moment(item.endDate).format('DD-MM-YYYY')}
                                </td> */}

                                                            </tr>
                                                        ))}
                                                    </tbody>

                                                </table>
                                                <div className="w-100 d-flex justify-content-center">
                                                    {count > 10 && (<Paginations setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />)}
                                                </div>
                                            </div>
                                    }

                                </>
                            }
                            {
                                tab === 2 &&
                                <>
                                    {
                                        !promotionalAddonDataAppointment?.length ? <NoRecord /> :

                                            <div className="table-responsive">
                                                <table className="table cus-table">
                                                    <thead className="text-center tableheader">
                                                        <tr>
                                                            <th scope="col">Client</th>
                                                            <th scope="col">Appointment Number</th>
                                                            <th scope="col">Start Time</th>
                                                            <th scope="col">End Time</th>
                                                            <th scope="col">Send Time</th>
                                                            <th scope="col">Delivered Time</th>
                                                            <th scope="col">Read Time</th>
                                                            <th scope="col">Status</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {promotionalAddonDataAppointment?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.userName}</td>
                                                                <td
                                                                    onClick={() => navigate(`/layout/appointmentList/appointmentView/${item?.appointmentData?._id}`)}
                                                                    style={{ cursor: 'pointer', color: 'blue' }}
                                                                >
                                                                    {item?.appointmentData?.appointment_number}
                                                                </td>
                                                                <td>{item?.appointmentData?.startDateTime ? moment(item?.appointmentData?.startDateTime).format("DD-MM-YYYY hh:mm A") : ""}</td>
                                                                <td>{item?.appointmentData?.endDateTime ? moment(item?.appointmentData?.endDateTime).format("DD-MM-YYYY hh:mm A") : ""}</td>


                                                                <td>{item.sentDateTime ? moment(item.sentDateTime).format("DD-MM-YYYY hh:mm A") : ""}</td>
                                                                <td>{item.deliveredDateTime ? moment(item.deliveredDateTime).format("DD-MM-YYYY hh:mm A") : ""}</td>
                                                                <td>{item.readDateTime ? moment(item.readDateTime).format("DD-MM-YYYY hh:mm A") : ''}</td>
                                                                <td>{item.status}</td>

                                                                {/* <td onClick={() => handleClick(item)}>
                                  {moment(item.startDate).format('DD-MM-YYYY')} To {moment(item.endDate).format('DD-MM-YYYY')}
                                </td> */}

                                                            </tr>
                                                        ))}
                                                    </tbody>

                                                </table>
                                                <div className="w-100 d-flex justify-content-center">
                                                    {countAppointment > 10 && (<Paginations setpage={setPageAppointment} count={Math.ceil(countAppointment / PER_PAGE)} page={pageAppointment} />)}
                                                </div>
                                            </div>
                                    }

                                </>
                            }

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PromotionalMessage